import MpsDataTable from "./component/mps-data-table/MpsDataTable";

export default {
    install(Vue) {
        Vue.use(MpsDataTable)
    }
};

